import axios from "axios";
import vue from '@/main'
import qs from "qs";
import store from "../store";


axios.defaults.withCredentials = true;
console.log("process.env.VUE_APP_BASE_API ",process.env )
const service = axios.create({
    // baseURL: '/guanwangapi/official/website', // 正式环境
    // baseURL: '/official/website', // 本地开发环境
    // baseURL: baseURL + '/website',
    baseURL: process.env.VUE_APP_BASE_API +'/website',
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 30000, // request timeout
});


// request interceptor
service.interceptors.request.use(
    (config) => {
        // do something before request is sent
        //语言
       
       let Language = store.getters.lang == 1 ? 'en_US' : 'zh_CN'
       console.log('3948389=dsdseds111',Language)
       config.headers.Language = Language
        console.log('2323=kljss',config)
        let url = config.url
        let data = config.data
        config.headers['Content-Type'] =config.headers['Content-Type'] || 'application/json'
        console.log('329382983======wewew', config, data)
        if (config.isformdata) {
            data = qs.parse(data);
            if (url.indexOf(':') > -1 && data) {
                // 链接参数更换
                for (var key in data) {
                    if (url.indexOf(':' + key) > -1) {
                        url = url.replace(':' + key, data[key])
                        delete data[key]
                    }
                }
            }
            config.data = qs.stringify(data)
            config.url = url
        } 
        
        if(config.type) {
            let str=''
            if (url.indexOf('?') > -1 && data) {
                // 链接参数更换
                for (var key in data) {
                    console.log('opopo===555',key,data[key])
                    str+=key+'='+data[key]+'&'
                    delete data[key]
                }
            }
           
            config.data = data
            config.url = url+str.slice(0,-1)
        }

        if (config.isparams) {
            console.log('439483===',data)
            url = url + data
            data = ''
            config.data = data
            config.url = url
        }
        console.log('21290192=====adad',config)
        return config;
    },
    (error) => {
        // do something with request error
        return Promise.reject(error);
    }
);

// response interceptor
service.interceptors.response.use(
    (response) => {
        const res = response.data;
        //res.code = 201
        if (res.code && res.code.data) {
            // console.log('333333res',res.msg);
            if (res.code !== 200) {
                return Promise.reject(new Error(res.msg || "Error"));
            } else {
                return res;
            }
        } else {
            return res;
        }
    },
    (error) => {
        if (error.response.data.code === 205) {
            if (error.response.data.msg) {
                return Promise.reject(error.response.data.msg);
            }
        } else {
            return Promise.reject(error);
        }
    }
);

export default service;



// WEBPACK FOOTER //
// ./src/api/index.js